var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"m-the-header-logo",attrs:{"to":"/gestion/productos-de-vidroop"}},[_c('AtomLogoPrimary')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }